import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { List } from 'immutable'
import {
  Button,
  Dialog,
  DialogActions,
  IconButton,
  Slide,
  Typography,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import withPromise from 'helpers/withPromise'
import { updateTaskAssignees, fetchJobTaskList } from 'reducers/myJobs/reducer'
import CircleLoader from 'components/Loading/CircleLoader'
import { REASSIGN_SERIES } from 'helpers/jobs'
import AssignChipsList from '../Common/AssignChipsList'
import messages from '../translate'

class ReassignDialog extends Component {
  constructor(props) {
    super(props)
    const { id, assigned_user_groups, assigned_users } = props.taskInfo
    this.state = {
      id,
      assignedUserGroups: assigned_user_groups.map(item => item.id),
      assignedUsers: assigned_users.map(item => item.id),
    }
  }

  onSetAssign = task => {
    this.setState({
      assignedUserGroups: task.assigned_user_groups,
      assignedUsers: task.assigned_users,
    })
  }

  onFormSubmit = () => {
    const {
      activeJob,
      updateTaskAssignees,
      fetchJobTaskList,
      onClose,
      reassignType,
      intl: { formatMessage },
    } = this.props
    const { id, assignedUserGroups, assignedUsers } = this.state
    const isSeriesJob = reassignType === REASSIGN_SERIES

    withPromise(updateTaskAssignees, {
      isSeriesJob,
      params: { id },
      form: {
        assigned_user_groups: assignedUserGroups,
        assigned_users: assignedUsers,
      },
      successMessage: formatMessage(messages.reassignSuccessMessage),
      errorMessage: formatMessage(messages.reassignErrorMessage),
    }).then(({ error }) => {
      if (!error) {
        fetchJobTaskList({
          activeJobId: activeJob.get('id'),
          skipLoader: false,
        })
        onClose()
      }
    })
  }

  render() {
    const {
      open,
      fullScreen,
      onClose,
      taskInfo,
      assignData,
      activeSite,
      activeJob,
      taskInfo: { assigned_user_groups, assigned_users },
      intl: { formatMessage },
    } = this.props
    const { id } = this.state
    const { loading } = this.props
    const siteName = activeSite.get('name')
    const jobName = activeJob.get('title')
    const taskName = taskInfo.title
    const actionName = formatMessage(messages.reassign)

    return (
      <Dialog
        open={open}
        fullScreen={fullScreen}
        onClose={onClose}
        classes={{
          root: 'add-workflow-dialog',
          paper: 'add-workflow-paper',
        }}>
        <DialogActions className="add-workflow-header">
          <Typography variant="h6" className="reassign-title">
            {`${siteName} / ${jobName} / ${taskName}: ${actionName}`}111
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </DialogActions>
        <div className="job-creation">
          {loading ? (
            <CircleLoader loading={loading} />
          ) : (
            <Slide in mountOnEnter unmountOnExit direction="left">
              <div className="creation-content">
                <div className="configuration-list">
                  <AssignChipsList
                    openOptions
                    taskId={id}
                    groups={assignData.get('groupList')}
                    groupsValues={List(assigned_user_groups)}
                    users={assignData.get('userList')}
                    usersValues={List(assigned_users)}
                    onChange={this.onSetAssign}
                  />
                </div>
                <Button
                  fullWidth
                  disabled={loading}
                  size="large"
                  color="primary"
                  variant="contained"
                  className="btn-step"
                  onClick={this.onFormSubmit}>
                  {formatMessage(messages.apply)}
                </Button>
              </div>
            </Slide>
          )}
        </div>
      </Dialog>
    )
  }
}

export default connect(
  state => ({
    assignData: state.getIn(['myJobs', 'assignData']),
    activeSite: state.getIn(['myJobs', 'activeSite']),
    activeJob: state.getIn(['myJobs', 'jobTask']),
    loading: state.getIn(['myJobs', 'loading']),
  }),
  {
    updateTaskAssignees,
    fetchJobTaskList,
  },
)(injectIntl(ReassignDialog))
